



































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getday } from '@/utils/formValidate'

import dayjs from 'dayjs';
@Component({
  name: 'Overview',
})
export default class extends Vue {
  @Prop() private overviewData!: any
  get days() {

    var today = dayjs().format('YYYY-MM-DD');
    var yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DD');

    
    return [yesterday.toString(), today.toString(),]
  }
}
